import { styled } from "../styling";
export const ControlButton = styled.button `
  transition: 0.2s ease-in-out;
  padding: 0;
  border: none;
  background-color: transparent;
  line-height: normal;
  color: ${(props) => props.theme.colors.foreground};
  &:hover {
    color: ${(props) => props.theme.colors.secondary};
  }
`;
//# sourceMappingURL=ControlButton.js.map